import { Wording } from '@/types';

export const YOGA_WORDING_FR: Wording = {
  components_header_media_content: 'Entraînements',
  components_header_media_1: '',
  components_header_media_2: '',
  components_header_text1: 'Recettes',
  components_header_text2: 'Blog',
  components_header_members: 'Membres',
  hero_text: 'Gardez votre corps flexible et fort',
  hero_button_text: 'Commencez votre voyage de yoga',
  components_ressources_section_title: 'RESSOURCES',
  components_ressources_subheader_text:
    'Toutes les ressources dont vous avez besoin pour un style de vie harmonieux',
  components_ressources_span_text:
    'Découvrez les secrets du bien-être : plongez dans une collection de poses de yoga, de méditations de pleine conscience et de recettes saines pour créer un équilibre dans tous les aspects de votre vie.',
  components_ressources_card_1_title: 'Conseils de yoga',
  components_ressources_card_1_text:
    'Des conseils pratiques pour approfondir votre pratique et perfectionner vos poses.',
  components_ressources_card_2_title: 'Régime',
  components_ressources_card_2_text:
    'Conseils nutritionnels intelligents pour être en meilleure santé et plus fort.',
  components_ressources_link: 'Regarder des vidéos',
  components_notes_and_google_title_1: 'Entraînements de yoga',
  components_notes_and_google_title_2: 'Routine régulière',
  components_notes_and_google_title_3: 'Entretien du régime',
  components_review_google_text: 'Avis sur Google',
  media_content_section_title: 'ENTRAÎNEMENTS',
  media_content_section_subheader_text: 'Nos vidéos',
  text_media_1: '',
  text_media_2: '',
  media_content_section_button_more: 'Plus de vidéos',
  text2_section_title: 'BLOG',
  text2_section_subheader_text: 'Articles et actualités',
  text2_section_button_more: "Plus d'articles",
  components_text1_section_title: 'RECETTES',
  components_text1_subheader_text: 'Nourrissez votre corps et votre esprit',
  components_text1_span_text:
    'Des recettes saines pour soutenir votre pratique du yoga et améliorer votre bien-être.',
  components_text1_card_1_title: 'Petits déjeuners énergisants',
  components_text1_card_1_text:
    'Réveillez-vous avec des repas vibrants et énergisants.',
  components_text1_card_3_title: 'Des déjeuners riches en énergie',
  components_text1_card_3_text:
    "Découvrez des recettes de déjeuner délicieuses et pratiques conçues pour votre style de vie actif. Des salades colorées aux wraps riches en protéines, ces recettes vous permettent de rester concentré et plein d'énergie.",
  components_text1_card_2_title: 'Dîners de récupération',
  components_text1_card_2_text:
    'Explorez une variété de protéines maigres, de grains entiers et de légumes vibrants pour une fin de journée satisfaisante.',
  components_text1_link: 'Voir toutes les recettes',
  components_footer_text:
    "Trouvez l'équilibre, respirez profondément : votre yoga, votre voyage.",
  components_footer_info: 'Informations',
  components_footer_registration_number: "Numéro d'enregistrement",
  components_footer_legal: 'Légal',
  components_footer_terms: 'Termes et conditions',
  components_footer_privacy: 'politique de confidentialité',
  button_load_more: 'Charger plus',
  page_media_1_content_hero_text: 'Entraînements de yoga',
  page_text1_hero_text: 'Recettes',
  page_text1_section_title: 'Nutrition',
  page_text1_subheader_text: 'Recettes',
  page_text2_hero_text: 'Notre blog',
  page_text2_section_title: 'Blog',
  page_text2_subheader_text: 'Articles et actualités',
  enter_email_title: 'Veuillez entrer votre email pour continuer',
  enter_email_placeholder_email: 'E-mail',
  enter_email_button_enter: 'Entrer',
  components_login_success_text: 'Connexion réussie !',
  components_card_link_media_content: 'Regarder maintenant',
  components_card_link_text1_content: 'Voir la recette',
  components_card_link_text2_content: "Voir l'article",
  france: 'France',
  cyprus: 'Chypre',
};
